import http from '../utils/http';

export default {
    findByFiltro(filtro) {
        return http.get({
            url: '/clientes',
            data: filtro
        });
    }
};
